'use client';

import { SpotMarketConfig } from '@velocity-exchange/sdk';
import { UIMarket } from '@velocity-exchange/common';
import { UiVaultConfig } from 'src/@types/vaults';
import { VaultDepositorStatsForSidebar } from './UserPerformance/VaultDepositorStatsForSidebar';
import { VaultDescription } from './VaultDescription';
import { VaultPerformance } from './VaultPerformance';
import { VaultPerformanceBreakdownForSidebar } from './VaultPerformance/VaultPerformanceBreakdown';
import { VaultStrategy } from './VaultStrategy';
import Divider from 'src/components/primitives/Divider/Divider';

export const VaultDetailsDrawerContent = (props: {
	uiVaultConfig: UiVaultConfig;
	onClose: () => void;
}) => {
	const strategyText = Array.isArray(
		props.uiVaultConfig.overviewSection?.[0]?.paragraphs?.[0]?.text
	)
		? props.uiVaultConfig.overviewSection?.[0]?.paragraphs?.[0]?.text[0]
		: props.uiVaultConfig.overviewSection?.[0]?.paragraphs?.[0]?.text;

	const description = props.uiVaultConfig.description;

	return (
		<div className="flex flex-col gap-2xl">
			<div className="flex flex-col gap-lg">
				<VaultDepositorStatsForSidebar
					depositAssetConfig={
						UIMarket.createSpotMarket(props.uiVaultConfig.depositAsset)
							.market as SpotMarketConfig
					}
					vaultPubkey={props.uiVaultConfig.vaultPubkeyString}
				/>

				<VaultPerformance uiVaultConfig={props.uiVaultConfig} />

				<Divider />

				{strategyText && <VaultStrategy strategy={strategyText} />}

				{description && <VaultDescription description={description} />}

				<Divider />

				<VaultPerformanceBreakdownForSidebar
					vaultPubkey={props.uiVaultConfig.vaultPubkeyString}
					depositAssetMarketIndex={props.uiVaultConfig.depositAsset}
				/>
			</div>
		</div>
	);
};
